export default __webpack_public_path__ + "static/media/news.7302ab8c.png";